export const integratorMenuDef = [
    {
        "name": "menu.integrator_dashboard_ws_format",
        "icon": "fa fa-building-o",
        "data": {
            "nav_url": "integrator_dashboard_ws_format"
        },
        "children": [
            {
                "name": "menu.dashboard",
                "resource": "integrator_dashboard_ws_format",
                "icon": "fa fa-file-text-o",
                "url": "integrator_dashboard_ws_format",
                "auto_crud": true,
                "breadcrumb": "integrator_dashboard",
                "check_permission": false
            },
            {
                "name": "menu.dashboard",
                "resource": "integrator_dashboard_ws_retry",
                "icon": "fa fa-file-text-o",
                "url": "integrator_dashboard_ws_retry",
                "auto_crud": true,
                "breadcrumb": "integrator_dashboard",
                "check_permission": false
            },
            {
                "name": "menu.dashboard",
                "resource": "integrator_dashboard_ai_format",
                "icon": "fa fa-file-text-o",
                "url": "integrator_dashboard_ai_format",
                "auto_crud": true,
                "breadcrumb": "integrator_dashboard",
                "check_permission": false
            },
            {
                "name": "menu.dashboard",
                "resource": "integrator_dashboard_db_format",
                "icon": "fa fa-file-text-o",
                "url": "integrator_dashboard_db_format",
                "auto_crud": true,
                "breadcrumb": "integrator_dashboard",
                "check_permission": false
            },
            {
                "name": "menu.dashboard",
                "resource": "integrator_dashboard_mems_format",
                "icon": "fa fa-file-text-o",
                "url": "integrator_dashboard_mems_format",
                "auto_crud": true,
                "breadcrumb": "integrator_dashboard",
                "check_permission": false
            },
            {
                "name": "menu.dashboard",
                "resource": "integrator_dashboard_iot_format",
                "icon": "fa fa-file-text-o",
                "url": "integrator_dashboard_iot_format",
                "auto_crud": true,
                "breadcrumb": "integrator_dashboard",
                "check_permission": false
            },
            {
                "name": "menu.dashboard",
                "resource": "integrator_dashboard_astm",
                "icon": "fa fa-file-text-o",
                "url": "integrator_dashboard_astm",
                "auto_crud": true,
                "breadcrumb": "integrator_dashboard",
                "check_permission": false
            },
            {
                "name": "menu.dashboard",
                "resource": "integrator_dashboard_hl7",
                "icon": "fa fa-file-text-o",
                "url": "integrator_dashboard_hl7",
                "auto_crud": true,
                "breadcrumb": "integrator_dashboard",
                "check_permission": false
            },
            {
                "name": "menu.dashboard",
                "resource": "integrator_dashboard_dicom",
                "icon": "fa fa-file-text-o",
                "url": "integrator_dashboard_dicom",
                "auto_crud": true,
                "breadcrumb": "integrator_dashboard",
                "check_permission": false
            }
        ]
    },
    {
        name: 'Integrator Master',
        resource: 'integrator_master',
        icon: 'fa fa-plus-square',
        url: 'integrator_master',
        auto_crud: true,
        breadcrumb: 'Integrator Master',
        showMenu: true
    },
    {
        name: 'Integrator Service Master',
        resource: 'integrator_service_master',
        icon: 'fa fa-plus-square',
        url: 'integrator_service_master',
        auto_crud: true,
        breadcrumb: 'Integrator Service Master',
        showMenu: true
    },
    {
        name: 'Integrator Service',
        resource: 'soap_service_config',
        icon: 'fa fa-plus-square',
        url: 'soap_service_config',
        auto_crud: true,
        breadcrumb: 'SOAP Service Config',
        showMenu: true
    },
    {
        name: 'Integrator Service',
        resource: 'rest_service_config',
        icon: 'fa fa-plus-square',
        url: 'rest_service_config',
        auto_crud: true,
        breadcrumb: 'REST Service Config',
        showMenu: true
    },
    {
        name: 'Channel Source',
        resource: 'channel_source',
        icon: 'fa fa-plus-square',
        url: 'channel_source',
        auto_crud: true,
        breadcrumb: 'Channel Source Config',
        showMenu: true
    },
    {
        name: 'InBound Service Config',
        resource: 'inbound_service_config',
        icon: 'fa fa-plus-square',
        url: 'inbound_service_config',
        auto_crud: true,
        breadcrumb: 'Inbound Service Config',
        showMenu: true
    },
    {
        name: 'Default FTP Service',
        resource: 'default_ftp',
        icon: 'fa fa-plus-square',
        url: 'default_ftp',
        auto_crud: true,
        breadcrumb: 'Default FTP Service',
        showMenu: true
    },
    {
        name: 'FTP Service',
        resource: 'ftp_service',
        icon: 'fa fa-plus-square',
        url: 'ftp_service',
        auto_crud: true,
        breadcrumb: 'FTP Service',
        showMenu: true
    },
    {
        name: 'Database Service',
        resource: 'database_service',
        icon: 'fa fa-plus-square',
        url: 'database_service',
        auto_crud: true,
        breadcrumb: 'Database Service',
        showMenu: true
    },
    {
        name: 'Database Tables',
        resource: 'database_tables',
        icon: 'fa fa-plus-square',
        url: 'database_tables',
        auto_crud: true,
        breadcrumb: 'Database Tables',
        showMenu: true
    },
    {
        name: 'Database Events',
        resource: 'database_events',
        icon: 'fa fa-plus-square',
        url: 'database_events',
        auto_crud: true,
        breadcrumb: 'Database Events',
        showMenu: true
    },
    {
        name: 'Copy Integrator',
        resource: 'integrator_copy',
        icon: 'fa fa-plus-square',
        url: 'integrator_copy',
        auto_crud: true,
        breadcrumb: 'Copy Integrator',
        showMenu: true
    },
    {
        name: 'Copy Integrator',
        resource: 'integration_facility_system_onboard',
        icon: 'fa fa-plus-square',
        url: 'integration_facility_system_onboard',
        auto_crud: true,
        breadcrumb: 'System OnBoard',
        showMenu: true
    },
    {
        name: 'System Onboard',
        resource: 'integration_onboard_format',
        icon: 'fa fa-plus-square',
        url: 'integration_onboard_format',
        auto_crud: true,
        breadcrumb: 'Facility System Onboard',
        showMenu: true
    },
    {
        name: 'Clone Integrator',
        resource: 'integrator_clone',
        icon: 'fa fa-plus-square',
        url: 'integrator_clone',
        auto_crud: true,
        breadcrumb: 'Clone Integrator',
        showMenu: true
    },
    {
        name: 'Clone Integrator Key',
        resource: 'integrator_key_clone',
        icon: 'fa fa-plus-square',
        url: 'integrator_key_clone',
        auto_crud: true,
        breadcrumb: 'Clone Integrator Key',
        showMenu: true
    },
    {
        name: 'Value Mapper',
        resource: 'value_mapper',
        icon: 'fa fa-plus-square',
        url: 'value_mapper',
        auto_crud: true,
        breadcrumb: 'Value Mapper',
        showMenu: true
    },
    {
        name: 'Integrator Dashboard',
        resource: 'integrator_dashboard',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard',
        auto_crud: true,
        breadcrumb: 'Integrator Dashboard',
        showMenu: true
    },
    {
        name: 'System Integration Dashboard',
        resource: 'integrator_dashboard_ws',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard_ws',
        auto_crud: true,
        breadcrumb: 'System Integration Dashboard',
        showMenu: true
    },
    {
        "name": "menu.dashboard",
        "resource": "ftp_dashboard_ws_format",
        "icon": "fa fa-plus-square",
        "url": "ftp_dashboard_ws_format",
        "auto_crud": true,
        "breadcrumb": "ftp_dashboard",
        "check_permission": false
    },
    {
        name: 'Orders Dashboard',
        resource: 'integrator_dashboard_orders_ws',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard_orders_ws',
        auto_crud: true,
        breadcrumb: 'FTP Integration Dashboard',
        showMenu: true
    },
    {
        name: 'Orders Dashboard',
        resource: 'integrator_dashboard_orders',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard_orders',
        auto_crud: true,
        breadcrumb: 'System Integration Dashboard',
        showMenu: true
    },
    {
        name: 'FTP Integration Dashboard',
        resource: 'ftp_dashboard_ws',
        icon: 'fa fa-plus-square',
        url: 'ftp_dashboard_ws',
        auto_crud: true,
        breadcrumb: 'FTP Integration Dashboard',
        showMenu: true
    },
    {
        name: 'FTP Integration Dashboard',
        resource: 'ftp_dashboard',
        icon: 'fa fa-plus-square',
        url: 'ftp_dashboard',
        auto_crud: true,
        breadcrumb: 'System Integration Dashboard',
        showMenu: true
    },
    {
        name: 'FTP Inbound Dashboard',
        resource: 'ftp_dashboard_inbound_ws',
        icon: 'fa fa-plus-square',
        url: 'ftp_dashboard_inbound_ws',
        auto_crud: true,
        breadcrumb: 'FTP Integration Dashboard',
        showMenu: true
    },
    {
        name: 'FTP Inbound Dashboard',
        resource: 'ftp_dashboard_inbound',
        icon: 'fa fa-plus-square',
        url: 'ftp_dashboard_inbound',
        auto_crud: true,
        breadcrumb: 'System Integration Dashboard',
        showMenu: true
    },
    {
        name: 'Database Integration Dashboard',
        resource: 'integrator_dashboard_db',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard_db',
        auto_crud: true,
        breadcrumb: 'Database Integration Dashboard',
        showMenu: true
    },
    {
        name: 'AI Integration Dashboard',
        resource: 'integrator_dashboard_ai',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard_ai',
        auto_crud: true,
        breadcrumb: 'AI Integration Dashboard',
        showMenu: true
    },
    {
        name: 'Medical IoT Integration Dashboard',
        resource: 'integrator_dashboard_iot',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard_iot',
        auto_crud: true,
        breadcrumb: 'Medical IoT Integration Dashboard',
        showMenu: true
    },
    {
        name: 'MEMS Integration Dashboard',
        resource: 'integrator_dashboard_mems',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard_mems',
        auto_crud: true,
        breadcrumb: 'MEMS Integration Dashboard',
        showMenu: true
    },
    {
        name: 'Integrator Inbound Dashboard',
        resource: 'integrator_dashboard_inbound',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard_inbound',
        auto_crud: true,
        breadcrumb: 'Integrator Inbound Dashboard',
        showMenu: true
    },
    {
        name: 'AI Inbound Dashboard',
        resource: 'integrator_dashboard_inbound_ai',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard_inbound_ai',
        auto_crud: true,
        breadcrumb: 'AI Inbound Dashboard',
        showMenu: true
    },
    {
        name: 'Medical IoT Inbound Dashboard',
        resource: 'integrator_dashboard_inbound_iot',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard_inbound_iot',
        auto_crud: true,
        breadcrumb: 'Medical IoT Inbound Dashboard',
        showMenu: true
    },
    {
        name: 'System Inbound Dashboard',
        resource: 'integrator_dashboard_inbound_ws',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard_inbound_ws',
        auto_crud: true,
        breadcrumb: 'System Inbound Dashboard',
        showMenu: true
    },
    {
        name: 'MEMS Inbound Dashboard',
        resource: 'integrator_dashboard_inbound_mems',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard_inbound_mems',
        auto_crud: true,
        breadcrumb: 'MEMS Inbound Dashboard',
        showMenu: true
    },
    {
        name: 'Integrator Master Mems',
        resource: 'integrator_master_mems',
        icon: 'fa fa-plus-square',
        url: 'integrator_master_mems',
        auto_crud: true,
        breadcrumb: 'Integrator Master Mems',
        showMenu: true
    },
    {
        name: 'Integrator Master AI',
        resource: 'integrator_master_ai',
        icon: 'fa fa-plus-square',
        url: 'integrator_master_ai',
        auto_crud: true,
        breadcrumb: 'Integrator Master ai',
        showMenu: true
    },
    {
        name: 'Integrator Master IOT',
        resource: 'integrator_master_iot',
        icon: 'fa fa-plus-square',
        url: 'integrator_master_iot',
        auto_crud: true,
        breadcrumb: 'Integrator Master IOT',
        showMenu: true
    },
    {
        name: 'Integrator Master DB',
        resource: 'integrator_master_db',
        icon: 'fa fa-plus-square',
        url: 'integrator_master_db',
        auto_crud: true,
        breadcrumb: 'Integrator Master DB',
        showMenu: true
    },
    {
        name: 'Integrator Master WS',
        resource: 'integrator_master_ws',
        icon: 'fa fa-plus-square',
        url: 'integrator_master_ws',
        auto_crud: true,
        breadcrumb: 'Integrator Master WS',
        showMenu: true
    },
    {
        name: 'Integrator Master FTP',
        resource: 'integrator_master_ftp',
        icon: 'fa fa-plus-square',
        url: 'integrator_master_ftp',
        auto_crud: true,
        breadcrumb: 'Integrator Master FTP',
        showMenu: true
    },
    {
        name: 'Payment Gateway Master',
        resource: 'integrator_master_pgw',
        icon: 'fa fa-plus-square',
        url: 'integrator_master_pgw',
        auto_crud: true,
        breadcrumb: 'Payment Gateway Master',
        showMenu: true
    },
    {
        name: 'Payment Gateway Connector',
        resource: 'rest_service_config_pgw',
        icon: 'fa fa-plus-square',
        url: 'rest_service_config_pgw',
        auto_crud: true,
        breadcrumb: 'Payment Gateway Connector Config',
        showMenu: true
    },
    {
        name: 'Payment Gateway Reciever',
        resource: 'inbound_service_config_pgw',
        icon: 'fa fa-plus-square',
        url: 'inbound_service_config_pgw',
        auto_crud: true,
        breadcrumb: 'Payment Gateway Reciever Config',
        showMenu: true
    },
    {
        name: 'Integrator Service WS',
        resource: 'soap_service_config_ws',
        icon: 'fa fa-plus-square',
        url: 'soap_service_config_ws',
        auto_crud: true,
        breadcrumb: 'SOAP Service Config WS',
        showMenu: true
    },
    {
        name: 'Integrator Service WS',
        resource: 'rest_service_config_ws',
        icon: 'fa fa-plus-square',
        url: 'rest_service_config_ws',
        auto_crud: true,
        breadcrumb: 'REST Service Config WS',
        showMenu: true
    },
    {
        name: 'InBound Service Config FTP',
        resource: 'inbound_service_config_ftp',
        icon: 'fa fa-plus-square',
        url: 'inbound_service_config_ftp',
        auto_crud: true,
        breadcrumb: 'Inbound Service Config FTP',
        showMenu: true
    },
    {
        name: 'FTP Service WS',
        resource: 'ftp_service_config',
        icon: 'fa fa-plus-square',
        url: 'ftp_service_config',
        auto_crud: true,
        breadcrumb: 'FTP Service Config WS',
        showMenu: true
    },
    {
        name: 'Integrator Service IOT',
        resource: 'soap_service_config_iot',
        icon: 'fa fa-plus-square',
        url: 'soap_service_config_iot',
        auto_crud: true,
        breadcrumb: 'SOAP Service Config IOT',
        showMenu: true
    },
    {
        name: 'Integrator Service IOT',
        resource: 'rest_service_config_iot',
        icon: 'fa fa-plus-square',
        url: 'rest_service_config_iot',
        auto_crud: true,
        breadcrumb: 'REST Service Config IOT',
        showMenu: true
    },
    {
        name: 'Integrator Service MEMS',
        resource: 'soap_service_config_mems',
        icon: 'fa fa-plus-square',
        url: 'soap_service_config_mems',
        auto_crud: true,
        breadcrumb: 'SOAP Service Config MEMS',
        showMenu: true
    },
    {
        name: 'Integrator Service MEMS',
        resource: 'rest_service_config_mems',
        icon: 'fa fa-plus-square',
        url: 'rest_service_config_mems',
        auto_crud: true,
        breadcrumb: 'REST Service Config MEMS',
        showMenu: true
    },
    {
        name: 'Integrator Service AI',
        resource: 'soap_service_config_ai',
        icon: 'fa fa-plus-square',
        url: 'soap_service_config_ai',
        auto_crud: true,
        breadcrumb: 'SOAP Service Config AI',
        showMenu: true
    },
    {
        name: 'Integrator Service AI',
        resource: 'rest_service_config_ai',
        icon: 'fa fa-plus-square',
        url: 'rest_service_config_ai',
        auto_crud: true,
        breadcrumb: 'REST Service Config AI',
        showMenu: true
    },
    {
        name: 'InBound Service Config MEMS',
        resource: 'inbound_service_config_mems',
        icon: 'fa fa-plus-square',
        url: 'inbound_service_config_mems',
        auto_crud: true,
        breadcrumb: 'Inbound Service Config MEMS',
        showMenu: true
    },
    {
        name: 'InBound Service Config MEMS',
        resource: 'inbound_service_config_mems',
        icon: 'fa fa-plus-square',
        url: 'inbound_service_config_mems',
        auto_crud: true,
        breadcrumb: 'Inbound Service Config MEMS',
        showMenu: true
    },
    {
        name: 'InBound Service Config WS',
        resource: 'inbound_service_config_ws',
        icon: 'fa fa-plus-square',
        url: 'inbound_service_config_ws',
        auto_crud: true,
        breadcrumb: 'Inbound Service Config WS',
        showMenu: true
    },
    {
        name: 'Integrator Master ',
        resource: 'integrator_master_dicom',
        icon: 'fa fa-plus-square',
        url: 'integrator_master_dicom',
        auto_crud: true,
        breadcrumb: 'Integrator Master dicom',
        showMenu: true
    },
    {
        name: 'Integrator Master ASTM',
        resource: 'integrator_master_astm',
        icon: 'fa fa-plus-square',
        url: 'integrator_master_astm',
        auto_crud: true,
        breadcrumb: 'Integrator Master Astm',
        showMenu: true
    },
    {
        name: 'Integrator Master HL7',
        resource: 'integrator_master_hl7',
        icon: 'fa fa-plus-square',
        url: 'integrator_master_hl7',
        auto_crud: true,
        breadcrumb: 'Integrator Master HL7',
        showMenu: true
    },
    {
        name: 'Integrator Facility Machine',
        resource: 'integrator_facility_machine',
        icon: 'fa fa-plus-square',
        url: 'integrator_facility_machine',
        auto_crud: true,
        breadcrumb: 'Integrator Facility Machine',
        showMenu: true
    },
    {
        name: 'Cloud Gateway',
        resource: 'cloud_gateway',
        icon: 'fa fa-plus-square',
        url: 'cloud_gateway',
        auto_crud: true,
        breadcrumb: 'Cloud Gateway',
        showMenu: true
    },
    {
        name: 'MQTT Device',
        resource: 'medical_iot_mqtt',
        icon: 'fa fa-plus-square',
        url: 'medical_iot_mqtt',
        auto_crud: true,
        breadcrumb: 'MQTT Device',
        showMenu: true
    },
    {
        name: 'NB-IoT Device',
        resource: 'medical_iot_nbiot',
        icon: 'fa fa-plus-square',
        url: 'medical_iot_nbiot',
        auto_crud: true,
        breadcrumb: 'NB-IoT Device',
        showMenu: true
    },
    {
        name: 'Cloud Device',
        resource: 'medical_iot_cloud',
        icon: 'fa fa-plus-square',
        url: 'medical_iot_cloud',
        auto_crud: true,
        breadcrumb: 'Cloud Device',
        showMenu: true
    },
    {
        name: 'System Integration Dashboard',
        resource: 'integrator_dashboard_ws_retry',
        icon: 'fa fa-plus-square',
        url: 'integrator_dashboard_ws_retry',
        auto_crud: true,
        breadcrumb: 'System Integration Dashboard',
        showMenu: true
    },
    {
        name: 'System Files',
        resource: 'integrator_files',
        icon: 'fa fa-plus-square',
        url: 'integrator_files',
        auto_crud: true,
        breadcrumb: 'System Files',
        showMenu: true
    },
    {
        name: 'I/O Connector',
        resource: 'io_connector',
        icon: 'fa fa-plus-square',
        url: 'io_connector',
        auto_crud: true,
        breadcrumb: 'I/O Connector',
        showMenu: true
    },
    {
        name: 'Auxiliary Auth Connectors',
        resource: 'auxiliary_auth_connector',
        icon: 'fa fa-plus-square',
        url: 'auxiliary_auth_connector',
        auto_crud: true,
        breadcrumb: 'Auxiliary Auth Connectors',
        showMenu: true
    }
]

